import React from "react"
import {
  unstable_HistoryRouter as HistoryRouter,
  HistoryRouterProps
} from "react-router-dom"

import { history as getHistory } from "shared/lib/browserHistory"

export function Router({ children }: { children: React.ReactNode }) {
  return (
    <HistoryRouter
      history={getHistory() as unknown as HistoryRouterProps["history"]}
    >
      {children}
    </HistoryRouter>
  )
}
